import { MERCHANT_CODE } from "./tenant";

export const configuredBackendBase = () => String(process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

/** Custom-domain requests must pass through the same ingress as their page.
 *  Local development, same-host platform URLs and Master keep their configured API. */
export function backendBaseUrl({ location = window.location, merchantCode = MERCHANT_CODE,
  configuredUrl = configuredBackendBase() } = {}) {
  const host = location.hostname.toLowerCase();
  const local = ["localhost", "127.0.0.1", "0.0.0.0", "::1", "[::1]"].includes(host)
    || host.endsWith(".localhost");
  const path = location.pathname;
  const master = path === "/master" || path.startsWith("/master/");
  let backendHost = "";
  try { backendHost = new URL(configuredUrl).hostname.toLowerCase(); } catch { /* Relative backend base. */ }
  // A prefix on a custom hostname is still checked against that hostname's
  // mapping. Sending it to the platform origin would bypass this conflict check.
  const customEntry = !merchantCode || (backendHost && backendHost !== host);
  // Clients are created once. Starting at a custom root must keep its host
  // after the router navigates to /login without reloading those clients.
  const customRoot = path === "/" && backendHost && backendHost !== host;
  return !local && (customRoot || (customEntry && path !== "/")) && !master
    ? "" : String(configuredUrl || "").trim().replace(/\/+$/, "");
}
